import { Config } from "../landing-config";
import { ico_picked } from "../map-config";


const maxFileRows = 500;
export const BTS_CONFIG: Config = {
    data: {
        route: 'nodo-operatore-attivo',
        page_title: 'Nodo Operativo Attivo - BTS Attiva | Open Fiber',
        service_title: 'Nodo Operativo Attivo - BTS Attiva',
        service_description: '',
        service_name: '',
        service_slug: 'noa',
        errorTimeout: 0,
        feasibilityModelSingle: false,
        feasibilityEnabled: true,
        api: {
            massiveImport: {
                massiveDetailsPath: '/serviziobts/massivep2p/detail',
                massiveUploadPath: '/point/serviziobts/massivep2p/upload',
                massiveDownloadPath: '/serviziobts/data/massive/import.xlsx',
                massiveP2pSalesforcePath: '/serviziobts/massivep2p/send-to-salesforce',
                max_file_rows: maxFileRows,
                info_message: null
            },
            p2pPath: '/point/serviziobts/p2p',
			bboxPath: '/point/bts/building',
			buildingSearchParams: null
        },
        dynamic_aend_name: ''
    },
    multiple_points: {
        variable: false,
        max: 1,
        points: {
            b_end: {
                default_method: 'address',
                switch_methods: true,
                address: true,
                pop: false,
                poi: false,
                pfs: false,
                roe: false,
                coordinates: true,
                id_building: false,
                id_bts_noa: true,
                id_bts_building: true, 
                id_school: false,
                city_noa: true,
                city_pop: false,
                city_poi: false,
                city_building: true,
                id_healthcare: false,
                upload: true,
                popAndPoiAutocomplete: false,
                punti_intermedi: false,
                pop_pcn_xpop: false,
            },
            a_end: null
        },
        initial_points: ['b_end']
    },
    map: {
        map_events: ['zoom_changed', 'bounds_changed', 'dragend', 'dblclick'],
        marker_has_label: false,
        marker_default_icon: ico_picked,
        clear_markers_zoom_level: 12
    },
    research_methods: {
        id_building: false,
        id_bts_noa: true,
        id_bts_building: true,
        id_school: false,
        id_healthcare: false,
        punti_intermedi: false,
        pop_pcn_xpop: false,
    },
    area_types: ['CoveredAGF'],
    area_types_short: null,
    kml: false,
    pop: {
        load: true,
        view_initial: false,
        click: false,
        loadCities: false
    },
    pcn: {
        load: true,
        view_initial: false,
        click: false
    },
    pop_agf: {
        load: false,
        view_initial: false,
        click: false
    },
    poi: {
        load: true,
        view_initial: false,
        click: false,
        x_pop: false,
        is_registered: false,
        custom_research_method: null,
        loadCities: false
    },
    pfs: {
        load: false,
        view_initial: false,
        click: false,
        type: 'PFS'
    },
    roe: {
        load: false,
        view_initial: false,
        click: false,
        type: 'ROE'
    },
    cno: {
        load: false,
        view_initial: false,
        click: false,
        type: 'CNO'
    },
    pozzetto: {
        load: false,
        view_initial: false,
        click: false,
        type: 'POZZETTO'
    },
    building: {
        load: true,
        click: true,
        placeholder: 'Insert Building ID'
    },
    noa: {
        load: true,
        click: true,
        placeholder: 'Insert NOA ID'
    },
    bts: {
        load: true,
        types: {
            NOA: {
                load: true,
                click: true,
                placeholder: 'Insert NOA ID'
            },
            BUILDING: {
                load: true,
                click: true,
                placeholder: 'Insert Building ID'
            }
        }
    },
    punti_intermedi: {
        load: false,
        types: null
    },
    pop_pcn_xpop: {
        load: false,
        types: null
    },
    school: {
        load: false,
        click: false,
        placeholder: 'Insert School ID'
    },
    healthcare: {
        load: false,
        click: false,
        placeholder: 'Insert Healthcare ID'
    }
}